module.exports = __webpack_public_path__ + "img/fish1.bfe0264c.png";